"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"
import { clearRowError } from "@/lib/row-error-store"

/**
 * A row's failure note belongs to the page it happened on. The store is module
 * state, so without this a note from /sounds follows the visitor to a sound
 * page (and back again). Mounted once in the root layout.
 */
export function RowErrorReset() {
  const pathname = usePathname()
  useEffect(() => {
    clearRowError()
  }, [pathname])
  return null
}
